import React from "react";

/**
 * [PONPISH] 쿠폰 안내 (React + TailwindCSS)
 * - Tailwind 설정이 된 환경을 전제로 작성합니다.
 * - 좌측 고정 목차(>=lg), 모바일 접이식 목차, 섹션 앵커 스크롤, 가독성 위주의 레이아웃 구성.
 */

const sections = [
  {
    id: "basics",
    title: "기본 규정",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>PONPISH 회원 전용이며, PONPISH APP에서 상품 구매 시 사용 가능합니다.</li>
        <li>쿠폰 간 중복 적용은 불가합니다.</li>
        <li>쿠폰과 포인트는 중복 사용 가능합니다.</li>
      </ul>
    ),
  },
  {
    id: "validity",
    title: "사용 기한",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>각 쿠폰은 명시된 사용 기한 내에서만 사용 가능합니다.</li>
        <li>쿠폰마다 사용 기한은 상이할 수 있습니다.</li>
      </ul>
    ),
  },
  {
    id: "cancel-return",
    title: "취소·반품 시 처리",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>쿠폰을 사용하여 구매한 주문이 취소 완료된 경우, 해당 쿠폰은 재사용 가능합니다.</li>
        <li>반품 시 사유·상품 상태·내부 정책에 따라 쿠폰 재발급이 제한될 수 있습니다.</li>
      </ul>
    ),
  },
  {
    id: "retention",
    title: "보관 및 삭제",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>사용이 종료된 쿠폰은 종료일로부터 3개월간 보관된 후 자동 삭제됩니다.</li>
      </ul>
    ),
  },
  {
    id: "etc",
    title: "기타",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>PONPISH에서 제공하는 모든 쿠폰은 운영 정책에 따라 변경될 수 있습니다.</li>
      </ul>
    ),
  },
];

function Toc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <nav className="hidden lg:block sticky top-24 h-[calc(100vh-6rem)] overflow-auto pr-6">
      <h2 className="text-sm font-semibold text-black mb-3">목차</h2>
      <ol className="space-y-2 text-sm">
        {sections.map((s) => (
          <li key={s.id}>
            <a
              href={`#${s.id}`}
              className="block rounded-md px-2 py-1 hover:bg-gray-100 transition text-black"
            >
              {s.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

function MobileToc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <details className="lg:hidden mb-4 rounded-xl border bg-white shadow-sm">
      <summary className="cursor-pointer select-none px-4 py-3 text-sm font-medium text-black">목차 열기</summary>
      <div className="border-t px-4 py-3">
        <ol className="space-y-2 text-sm">
          {sections.map((s) => (
            <li key={s.id}>
              <a href={`#${s.id}`} className="block rounded-md px-2 py-1 hover:bg-gray-100 text-black">
                {s.title}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </details>
  );
}

export default function PonpishCouponGuidePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* 컨테이너 */}
      <main className="mx-auto max-w-6xl px-2 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-8">
          <Toc sections={sections.map(({ id, title }) => ({ id, title }))} />

          <article className="min-w-0">
            <div className="rounded-2xl border bg-white p-6">
              <h1 className="text-2xl font-bold tracking-tight text-black">[PONPISH] 쿠폰 안내</h1>
              <p className="mt-2 mb-4 text-sm text-gray-600">시행일: 2025년 8월 1일</p>

              <MobileToc sections={sections.map(({ id, title }) => ({ id, title }))} />

              <div className="divide-y">
                {sections.map((s) => (
                  <section id={s.id} key={s.id} className="scroll-mt-24 py-6">
                    <h2 className="text-lg font-semibold mb-3 text-black">{s.title}</h2>
                    <div className="space-y-3 leading-7 text-black">{s.body}</div>
                  </section>
                ))}
              </div>

              <footer className="mt-6 border-t pt-4 text-xs text-gray-600">
                법령·서비스 변경에 따라 본 문서는 갱신될 수 있습니다.
              </footer>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
}
